export const de_de = {
  validation_error: 'Dieses Feld ist erforderlich.',
  all: 'Alles',
  filter_result_text: 'ZEIGEN',
  filter_msg_title: 'Keine Ergebnisse gefunden',
  filter_msg: "Wir konnten nicht finden, wonach Sie gesucht haben. Versuchen Sie erneut zu suchen.",
};